// src/services/AdminService.js
// const API_BASE_URL = 'http://localhost:5142/api';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const token = localStorage.getItem('token');

const headers = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token}`,
};

// 1. Admin yap
export async function giveAdmin(username) {
  const response = await fetch(`${API_BASE_URL}/Admin/give-admin/${username}`, {
    method: 'POST',
    headers,
  });

  if (!response.ok) throw new Error('Admin yetkisi verilemedi.');
  return response.json();
}

// 2. Adminlikten çıkar
export async function revokeAdmin(username) {
  const response = await fetch(`${API_BASE_URL}/Admin/revoke-admin/${username}`, {
    method: 'POST',
    headers,
  });

  if (!response.ok) throw new Error('Admin yetkisi kaldırılamadı.');
  return response.json();
}

// 3. Duyuru oluştur
export async function createAnnouncement(title, content, photoUrl) {
  const token = localStorage.getItem('token');

  const bodyObj = {
    title: title || '',
    content: content || '',
  };

  if (photoUrl) {
    bodyObj.photoUrl = photoUrl;
  }

  const response = await fetch(`${API_BASE_URL}/Admin/create-announcement`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(bodyObj),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.failMessage || 'Duyuru oluşturulamadı');
  }

  return response.json();
}


export async function getAllAnnouncements() {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/Admin/get-all-announcements`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Duyurular alınamadı.');
  }
  return response.json();
}

// 5. Duyuru sil

export async function deleteAnnouncement(id) {
  const token = localStorage.getItem('token'); // 🔹 her çağrıda güncel token'ı al
  const response = await fetch(`${API_BASE_URL}/Admin/delete-announcement/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Duyuru silinemedi. (${response.status}): ${text}`);
  }

  return response.json();
}


// Öğrencileri sayfalı getir
export async function getAllUsersPaged(page) {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/Admin/get-all-users/paged?page=${page}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.failMessage || 'Kullanıcılar alınamadı');
  }

  return response.json();
}

// Öğrenci sil
export async function deleteStudent(id) {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/Admin/delete-student/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.failMessage || 'Öğrenci silinemedi');
  }

  return response.json();
}


// Admin Post sil
export async function deletePostAdmin(postId) {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/Admin/delete-post-admin/${postId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.Message || 'Post silinemedi.');
  }
  return response.json();
}

// Admin Comment sil
export async function deleteCommentAdmin(commentId) {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/Admin/delete-comment-admin/${commentId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.Message || 'Yorum silinemedi.');
  }
  return response.json();
}

// Post & Comment arama
export async function searchPostsAndComments(keyword) {
  const token = localStorage.getItem('token');
  const [postsRes, commentsRes] = await Promise.all([
    fetch(`${API_BASE_URL}/Admin/get-posts-by-keyword/${encodeURIComponent(keyword)}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }).then(res => res.json()),
    fetch(`${API_BASE_URL}/Admin/get-comments-by-keyword/${encodeURIComponent(keyword)}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }).then(res => res.json()),
  ]);

  return {
    posts: postsRes || [],
    comments: commentsRes || [],
  };
}

// 4. E-posta gönder
export async function sendEmail(subject, body, recipientEmailsString = '') {
  const token = localStorage.getItem('token');

  const recipientEmails = recipientEmailsString
    .split(',')
    .map(email => email.trim())
    .filter(email => email);

  const payload = {
    subject,
    body,
    recipientEmails: recipientEmails.length ? recipientEmails : null,
  };

  const response = await fetch(`${API_BASE_URL}/Admin/send-email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.failMessage || 'E-posta gönderimi başarısız.');
  }

  return response.json();
}

// 6. Şifre Sıfırlama Biletlerini Getir
export async function getPasswordResetTickets() {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/Admin/get-password-reset-tickets`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Biletler alınamadı.');
  }
  return response.json();
}

// 7. Kullanıcı Şifresini Değiştir (Admin)
export async function adminChangePassword(email, newPassword) {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/Admin/admin-change-password`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ email, newPassword }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.failMessage || 'Şifre değiştirilemedi.');
  }
  return response.json();
}

export async function deletePasswordResetTicket(id) {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/Admin/delete-password-reset-ticket/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.failMessage || 'Bilet silinemedi.');
  }
  return response.json();
}
